import { Crown } from "lucide-react";
import { useSettings } from "../contexts/SettingsContext";

export default function Logo({ className = "", size = "md", showText = true }) {
    const { settings } = useSettings();
    // When custom logo is uploaded, use an explicit box (image is object-contained inside).
    const customDims = size === "lg" ? "h-20 w-20" : size === "sm" ? "h-12 w-12" : "h-14 w-14";
    const dims = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-7 w-7" : "h-10 w-10";
    const text = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl";
    const title = settings?.site_title || "Purple Kings";
    const tagline = settings?.tagline || "Level Up · ABA";
    const hasCustomLogo = !!settings?.logo_url;

    return (
        <div data-testid="brand-logo" className={`flex items-center gap-3 ${className}`}>
            {hasCustomLogo ? (
                <img
                    src={settings.logo_url}
                    alt={title}
                    className={`${customDims} flex-shrink-0 object-contain`}
                />
            ) : (
                <div className={`${dims} flex-shrink-0 relative grid place-items-center bg-purple-dark border border-gold/60 rotate-45`}>
                    <Crown className="-rotate-45 text-gold" size={size === "lg" ? 28 : size === "sm" ? 16 : 22} strokeWidth={2.4} />
                </div>
            )}
            {showText && !hasCustomLogo && (
                <div className="leading-none whitespace-nowrap">
                    <div className={`h-display ${text} text-white tracking-tight`}>{title}</div>
                    <div className="text-[0.6rem] tracking-[0.3em] text-gold font-bold uppercase mt-1">{tagline}</div>
                </div>
            )}
        </div>
    );
}
